import { get as lodashGet, set as lodashSet } from 'lodash';

import accessTypeOptions from '../../../enums/access-type'

import template from './additional-items.jade';

export default angular
  .module('cian.addForm.buildingAdditionalItems', [])
  .directive('cianAfAboutBuildingAdditionalItems', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: ['$scope', function($scope) {
      // TODO вынеси в Enum
      this.items = [{
        title: 'Вентиляция',
        modelName: 'building.ventilationType',
        items: [{
          text: 'естественная',
          value: 'natural'
        }, {
          text: 'приточная',
          value: 'forced'
        }, {
          text: 'нет',
          value: 'no'
        }]
      }, {
        title: 'Кондиционир-е',
        modelName: 'building.conditioningType',
        items: [{
          text: 'местное',
          value: 'local'
        }, {
          text: 'центральное',
          value: 'central'
        }, {
          text: 'нет',
          value: 'no'
        }]
      }, {
        title: 'Отопление',
        modelName: 'building.heatingType',
        items: [{
          text: 'автономное',
          value: 'autonomous'
        }, {
          text: 'центральное',
          value: 'central'
        }, {
          text: 'нет',
          value: 'no'
        }]
      }, {
        title: 'Система пожаротуш-я',
        modelName: 'building.extinguishingSystemType',
        items: [{
          text: 'гидрантная',
          value: 'hydrant'
        }, {
          text: 'спринклерная',
          value: 'sprinkler'
        }, {
          text: 'порошковая',
          value: 'powder'
        }, {
          text: 'газовая',
          value: 'gas'
        }, {
          text: 'сигнализация',
          value: 'alarm'
        }, {
          text: 'нет',
          value: 'no'
        }]
      }];

      this.items = this.items.map(item => {
        const getLastValue = (model, item) => lodashGet(model, item.modelName) || item.items[0].value;

        let lastValue = getLastValue(this.ad, item);
        let modelIsOn = !!lodashGet(this.ad, item.modelName);

        Object.defineProperty(item, 'modelIsOn', {
          get: () => {
            return modelIsOn;
          },
          set: value => {
            if (value) {
              modelIsOn = true;
              lodashSet(this.ad, item.modelName, lastValue);
            }
            else {
              modelIsOn = false;
              lastValue = getLastValue(this.ad, item);
              lodashSet(this.ad, item.modelName, undefined);
            }
          }
        });

        Object.defineProperty(item, 'model', {
          get: () => {
            return lodashGet(this.ad, item.modelName);
          },
          set: value => {
            lastValue = value;
            modelIsOn = true;
            lodashSet(this.ad, item.modelName, value);
          }
        });

        $scope.$watch(() => lodashGet(this.ad, item.modelName), (newValue, oldValue) => {
          if (newValue === oldValue) return;

          item.model = newValue;
          item.modelIsOn = newValue;
        });

        return item;
      });
    }],
    controllerAs: 'additionalItems',
    template,
  }))
  .name;
